import { combineReducers } from 'redux';
import campaign from './campaign.reducer';

const reducer = combineReducers({
	campaign
});

export default reducer;
